import { apiClient } from './axios';
import type { LanguageSpecItem, UpdateLanguageSpecRequest, SyncMetaItem } from '../types/settings';

export const settingsApi = {
    getLanguages: () =>
        apiClient.get<LanguageSpecItem[]>('/admin/settings/languages'),

    updateLanguage: (code: string, data: UpdateLanguageSpecRequest) =>
        apiClient.patch<LanguageSpecItem>(`/admin/settings/languages/${code}`, data),

    getSyncMeta: () =>
        apiClient.get<SyncMetaItem>('/admin/settings/sync-meta'),
};
